import { styled } from '@mui/material/styles';

const StyledEntryCards = styled('div')(
  ({ theme }) => `
  
    overflow: hidden;
    margin-top: -${theme.spacing(['md'])};


    ${theme.breakpoints.up('lg')} {
      margin-top: -${theme.spacing(['xl'])};
    }
  `,
);

export { StyledEntryCards };
